import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TemplateModel } from '@fi-app/template/template.model';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { TemplateLayoutService } from '@fi-app/template/template-layout.service';
import { TemplateLayoutModel } from '@fi-app/template/template-layout.model';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { DropdownListSettingsLanguageModel } from '@fi-shared/dropdown';
import { StatisticService } from '@fi-app/shared/statistic/statistic.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { AppTextService } from '@fi-shared/app-text';
import { IDropdownSelectLanguageSettingsItem } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiItemsEditHelperService } from '@fi-shared/fi-shared-services/fi-items-edit-helper.service';
import { DocumentTemplateService } from '@fi-app/document-template/document-template.service';
import { FiHighlightService } from '@fi-shared/fi-highlight/fi-highlight.service';

@Component({
    selector: 'fi-document-template-view',
    templateUrl: './document-template-view.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../document-template-common.scss', './document-template-view.component.scss'],
    standalone: false,
})
export class FiDocumentTemplateViewComponent implements OnInit {
    @Input('template') Template: TemplateModel;
    @Input() highlightText: string;

    EditTabs: EditTabsModel;
    MoreMenuItems = new MoreMenuMobileSettingsModel();

    WriteAccessRight: boolean;
    templateLayout: TemplateLayoutModel;
    selectedLanguageId: number;
    LanguageListData: DropdownListSettingsLanguageModel<IDropdownSelectLanguageSettingsItem>;
    ShowLanguageSelector: boolean;
    Device = 800;
    MobileLanguages = {
        Show: false,
    };

    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private documentTemplateService: DocumentTemplateService,
        private templateLayoutService: TemplateLayoutService,
        private templateLayoutLanguageService: TemplateLayoutLanguageService,
        private itemsEditHelperService: FiItemsEditHelperService,
        private contentLanguagesService: ContentLanguagesService,
        private statisticService: StatisticService,
        private stateService: FiStateService,
        private customerDataService: FiCustomerDataService,
        private highlightService: FiHighlightService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit(): void {
        this.WriteAccessRight =
            this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Document.Template.Edit) &&
            this.Template.AccessRightFilterCollection.HasEditAccess;
        this.templateLayout = this.templateLayoutService.GetLayout(this.Template);
        this.templateLayoutService.TemplatePlaceHolderCollectionToLayout(
            this.Template.PlaceHolderCollection,
            this.templateLayout,
        );
        this.templateLayoutLanguageService.InitDefaultLanguageFromLayout(this.templateLayout);
        this.selectedLanguageId = this.templateLayoutLanguageService.selectedLanguage;
        this.LanguageListData = this.contentLanguagesService.GetDropdownListSettingsLanguage();
        this.ShowLanguageSelector = this.customerDataService.customerData.ContentLanguages.length > 1;
        this.statisticService.Visit(ModuleType.Template, ObjectTypes.Template, this.stateService.params.Id);
        this.EditTabs = new EditTabsModel(this.Template.Name);

        if (this.ShowLanguageSelector)
            this.MoreMenuItems.AddListItem(this.appTextService.get('common.select_lang'), () => {
                this.MobileLanguages.Show = true;
            });

        if (!!this.highlightText) this.highlightService.setHighlightText(this.highlightText);
    }

    IsDefaultLanguage(ContentLanguageId) {
        return this.templateLayoutLanguageService.IsDefaultLanguage(ContentLanguageId);
    }

    onLanguageChangeMobile($event) {
        this.MobileLanguages.Show = false;
        this.selectedLanguageId = $event;
        this.onLanguageChange();
    }

    onLanguageChange() {
        this.templateLayoutLanguageService.selectLanguage(this.selectedLanguageId);
    }

    editDocumentTemplate() {
        this.itemsEditHelperService.showEditRestoreConfirm(
            this.Template.Name,
            this.Template.IsDeleted,
            () => this.stateService.go(FiStateNames.Document.Template.Edit, { Id: this.Template.Id }),
            () => this.documentTemplateService.RestoreTemplates([this.Template.Id]),
        );
    }
}
